module.exports = __webpack_public_path__ + "static/img/10.7882ada.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/eng/10.png
// module id = hWMb
// module chunks = 0